import type { IconConfig } from '@epilot/journey-logic-commons'
import type { MaterialSymbol } from 'material-symbols'
import type { ChangeEvent } from 'react'

import { TextField, Icon } from '../../components'

interface TextInputControlProps {
  isDisabled?: boolean
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  value: string
  label?: string
  placeholder: string
  isRequired?: boolean
  id: string
  iconProps?: IconConfig | undefined
  helperText: string
  isError: boolean
  isTextarea?: boolean
}

export const TextInputControl = ({
  isDisabled,
  onChange,
  value,
  label,
  placeholder,
  isRequired,
  id,
  iconProps,
  helperText,
  isError,
  isTextarea
}: TextInputControlProps) => {
  const iconName = iconProps?.name as MaterialSymbol

  return (
    <TextField
      backgroundColor="var(--concorde-input-background)"
      color="var(--concorde-secondary-text)"
      helperText={helperText}
      id={id}
      isDisabled={isDisabled}
      isError={isError}
      isRequired={isRequired}
      isTextarea={isTextarea}
      label={label}
      onChange={onChange}
      placeholder={placeholder}
      startAdornment={iconName ? <Icon {...iconProps} name={iconName} /> : null}
      value={value || ''}
    />
  )
}
